import React from "react";
import { Field, reduxForm } from "redux-form";
import { TextField } from "redux-form-material-ui";
import Grid from "@material-ui/core/Grid";
import { munvoBlue } from "../utils/globalStyles";

let FolderForm = props => {
  const { handleSubmit } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={12}>
          <Field
            component={TextField}
            floatingLabelText="Name"
            name="name"
            hintText="New Folder"
            underlineStyle={{ borderColor: munvoBlue }}
            underlineFocusStyle={{ borderColor: munvoBlue }}
            floatingLabelFocusStyle={{ color: munvoBlue }}
          />
        </Grid>
      </Grid>
    </form>
  );
};

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = "Required";
  }
  return errors;
};

FolderForm = reduxForm({
  form: "folderform", // a unique identifier for this form,
  validate,
  onSubmit: (values, dispatch, props) => {
    props.submitCallback(values);
  }
})(FolderForm);

export default FolderForm;
